module.exports = __webpack_public_path__ + "img/body_flexion.d7315e7a.png";